import { useEffect } from "react";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useDeletePortfolioMutation } from "../../features/portfolio/portfolioApi";
import swalWithBootstrapButtons from "../../hooks/swalWithBootstrapButtons";

export default function PortfolioTableRow({ portfolio = {} }) {
  const { id, title, description, image, link, tag } = portfolio || {};
  const [
    deletePortfolio,
    { isSuccess: deletedIsSuccess, isError: deletedIsError },
  ] = useDeletePortfolioMutation();

  useEffect(() => {
    if (!deletedIsError && deletedIsSuccess) {
      swalWithBootstrapButtons.fire(
        "Deleted!",
        "Portfolio Delete Successfully.",
        "success"
      );
    } else if (deletedIsError) {
      swalWithBootstrapButtons.fire(
        "Error",
        "Portfolio Delete Error! :)",
        "error"
      );
    }
  }, [deletedIsError, deletedIsSuccess]);

  const handleDelete = () => {
    swalWithBootstrapButtons
      .fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel!",
        reverseButtons: true,
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          deletePortfolio(id);
        }
      });
  };
  return (
    <tr key={id} className="text-center">
      <td>{id}</td>
      <td>{title}</td>
      <td>{description}</td>
      <td>{link}</td>
      <td>{tag?.map((t) => `${t?.value}, `)}</td>
      <td>
        <img src={image} title="" alt={title} width={200} />
      </td>
      <td>
        <Link
          className="mx-2 btn btn-outline-success"
          to={`/user/portfolio/edit/${id}`}
        >
          Edit
        </Link>
        <button className="mx-2 btn btn-outline-danger" onClick={handleDelete}>
          Delete
        </button>
      </td>
    </tr>
  );
}
